// extracted by mini-css-extract-plugin
module.exports = {"genericModal":"GenericModal_genericModal__9VmjR","rotation":"GenericModal_rotation__JLgk8"};